import advanceAccount from './HSBC-advance.png';
import everydayGlobalAccountAdvance from './HSBC-everyday-advance.png';
import everydayGlobalAccountMass from './HSBC-everyday-mass.png';
import everydayGlobalAccountPremier from './HSBC-everyday-premier.png';
import massAccount from './HSBC-mass.png';
import premierAccount from './HSBC-premier.png';

export default {
  advanceAccount,
  premierAccount,
  massAccount,
  everydayGlobalAccountAdvance,
  everydayGlobalAccountPremier,
  everydayGlobalAccountMass,
};
